import { ComputeStrategy } from "components/workflow-template-editor/model";

const DEFAULT_PROJECTED_DATE_LABEL = "Projected Date";
const COMMITTED_DATE_LABEL = "Committed date";
const DEFAULT_EXPECTED_ONSITE_DATE_LABEL = "Projected Onsite Date";
const COMMITTED_EXPECTED_ONSITE_DATE_LABEL = "Committed Onsite Date";

export type MaterialTimelineVariant = {
  projectedDateLabel: string;
  expectedOnsiteDateLabel: string;
  forceFirstMilestoneReadOnly: boolean;
  canMarkCompleteWhenNoPrevious: boolean;
  /** When true, blank projected/committed dates are not treated as order errors. */
  allowEmptyProjectedDate: boolean;
};

/** BE may send enum string or numeric id (1=duration, 2=committed) until fixed. */
export function isCommittedDateComputeStrategy(
  strategy?: ComputeStrategy | string | number | null
): boolean {
  return (
    strategy === ComputeStrategy.COMMITTED_DATE_DRIVEN ||
    strategy === 2 ||
    strategy === "2"
  );
}

export function getMaterialTimelineVariant(
  strategy?: ComputeStrategy | string | number | null
): MaterialTimelineVariant {
  if (isCommittedDateComputeStrategy(strategy)) {
    return {
      projectedDateLabel: COMMITTED_DATE_LABEL,
      expectedOnsiteDateLabel: COMMITTED_EXPECTED_ONSITE_DATE_LABEL,
      forceFirstMilestoneReadOnly: false,
      canMarkCompleteWhenNoPrevious: true,
      allowEmptyProjectedDate: true
    };
  }

  return {
    projectedDateLabel: DEFAULT_PROJECTED_DATE_LABEL,
    expectedOnsiteDateLabel: DEFAULT_EXPECTED_ONSITE_DATE_LABEL,
    forceFirstMilestoneReadOnly: true,
    canMarkCompleteWhenNoPrevious: false,
    allowEmptyProjectedDate: false
  };
}

export function getProjectedDateFieldLabel(
  strategy?: ComputeStrategy | string | number | null
): string {
  return getMaterialTimelineVariant(strategy).projectedDateLabel;
}
